/* ==================================================================================================
   LECTURE CRITIQUE D'ARTICLE — le domaine de l'onglet LCA : ce qu'est un sujet, comment on les trie,
   et le chargement des documents de cours.

   Les sujets viennent de LCA Pro (lcapro.fr), récupérés avec un abonnement par scripts/lcapro_scraper.py
   du dépôt QCM, puis déposés dans edn_data/qcm/ comme n'importe quel export edn.fr : ce sont des quiz
   numérotés 2001-2499 (annales) et 2501-2999 (entraînements), portant un bloc « lca » (type, année,
   thèmes, article). La séance elle-même est déléguée au moteur de QCM, qui sait déjà tout faire
   (barème EDN, corrections, maîtrise).

   Le cours réunit trois choses : le polycopié de la faculté (déposé dans edn_data/lca/ ou dans le dossier
   Drive de $lca_folder_id ; actions lca_cours et lca_fichier) ; le cours de LCA Pro, pages HTML du même
   scraper déposées dans edn_data/lca_cours/ (actions lca_cours_index et lca_cours_page) ; et le mémo de
   méthode, celui qu'on relit la veille.

   LE RENDU DE LA PAGE N'EST PLUS ICI : il est dans src/ui/pages/lca.js (lot B9), qui repose
   window.renderLcaTab et toutes les actions lca* sur les siennes. Ce fichier ne garde que le domaine et
   le chargement. Les déclarations des rendus historiques restent posées, vidées de leur corps, pour que
   l'inventaire des globales (scripts/inventaire_globals.py) tienne jusqu'au lot de clôture qui les retirera.
   ================================================================================================== */
(function () {
    var S = window.state;

    // Plages de numéros attribuées par le scraper, une fois pour toutes (lca_numeros.json).
    var ANNALES = [2001, 2499], ENTRAINEMENT = [2501, 2999];
    window.LCA_PLAGES = { annales: ANNALES, entrainement: ENTRAINEMENT };

    // Un numéro de quiz est-il un sujet de LCA ? Le bloc « lca » de l'index fait foi ; la plage de numéros
    // sert de secours pour un fichier déposé sans ce bloc (export fait à la main, par exemple).
    window.estSujetLca = function (n, ix) {
        n = parseInt(n, 10);
        if (ix && ix.lca) return true;
        return n >= ANNALES[0] && n <= ENTRAINEMENT[1];
    };
    function genre(n, ix) {
        var t = ix && ix.lca ? String(ix.lca.type || '').toLowerCase() : '';
        if (t.indexOf('annale') === 0) return 'annales';
        if (t) return 'entrainement';
        return parseInt(n, 10) <= ANNALES[1] ? 'annales' : 'entrainement';
    }
    // Les sujets d'un genre, les plus récents d'abord (l'année quand elle est connue, sinon le numéro).
    window.lcaSujets = function (g) {
        var idx = (S.qcm && S.qcm.index) || {};
        return Object.keys(idx).filter(function (n) { return window.estSujetLca(n, idx[n]) && genre(n, idx[n]) === g; })
            .sort(function (a, b) {
                var ya = parseInt((idx[a].lca || {}).annee, 10) || 0, yb = parseInt((idx[b].lca || {}).annee, 10) || 0;
                if (ya !== yb) return yb - ya;
                return parseInt(b, 10) - parseInt(a, 10);
            });
    };

    // ---------------------------------------------------------------- état de l'onglet
    // Les valeurs par défaut sont posées par src/ui/pages/lca.js, qui repose window.lcaEtat sur la sienne ;
    // ici on ne garantit que l'existence de l'objet, pour les chargements ci-dessous.
    function etat() { S.lca = S.lca || {}; return S.lca; }

    // Cours, fiches réflexes et blog de LCA Pro : pages HTML autonomes déposées dans edn_data/lca_cours/ avec leur
    // index.json, servies par api.php (lca_cours_page) qui réécrit images et liens internes. Rien à voir avec le
    // polycopié de la faculté : c'est le cours du site, chapitre par chapitre, en complément.
    window.lcaChargerCoursPro = function () {
        var L = etat();
        if (L.pro || L.proBusy) return;
        L.proBusy = true;
        var fini = function (pages) { L.pro = pages || []; L.proBusy = false; window.renderContent(); };
        window.syncWithServer('lca_cours_index', {}, function (d) { fini(d && d.success ? d.pages : []); });
    };

    window.lcaChargerCours = function (force) {
        var L = etat();
        if (L.coursBusy) return;
        L.coursBusy = true; L.coursErreur = null;
        window.renderContent();
        window.syncWithServer('lca_cours', force ? { force: true } : {}, function (d) {
            L.coursBusy = false; L.coursCharge = true;
            if (d && d.success) { L.cours = d; if (!L.doc && (d.fichiers || []).length) L.doc = d.fichiers[0].cle; }
            else L.coursErreur = (d && d.message) || 'documents de cours indisponibles';
            window.renderContent();
        });
    };

    // ------------------------------------------------------- les treize chapitres du polycopié
    // Un podcast par chapitre, numéros 401 à 413 (scripts déposés par scripts/lca_podcasts.py dans
    // <edn_data>/podcasts/<n>/item.json). Ce sont des podcasts comme les autres : même inventaire
    // (podcast_index), même lecteur, même synthèse vocale, même reprise après coupure. Le numéro ne
    // correspond à aucun item du programme : c'est ici, et seulement ici, qu'on sait ce qu'il désigne.
    var LCA_CHAPITRES = [
        [401, '1.1', "Structure d'un article"],
        [402, '1.2', "Les différents types d'étude"],
        [403, '1.3', "Échantillon, populations, fluctuations"],
        [404, '1.4', 'Biais et validité interne'],
        [405, '1.5', 'Validité externe'],
        [406, '1.6', "Niveau de preuve d'une étude"],
        [407, '1.7', 'Notions de biostatistiques'],
        [408, '2.1', "Évaluation d'un traitement"],
        [409, '2.2', 'Évaluation étiologique'],
        [410, '2.3', 'Facteurs pronostiques'],
        [411, '2.4', 'Test diagnostique'],
        [412, '2.5', 'Dépistage'],
        [413, '2.6', 'Revues systématiques et méta-analyses'],
    ];
    window.LCA_CHAPITRES = LCA_CHAPITRES;
    window.lcaChapitrePodcast = function (n) { return window.podcastFor ? window.podcastFor(String(n), '', false, false) : null; };

})();
